export default "__VITE_ASSET__d0db03f7__"